import { isWithinCutWindow } from './is-within-cut-window';

/**
 * Statements can be added before the cut has an end (F2 -> statement -> F9, or
 * F8 -> statement -> F9 while widening a saved cut), but never outside the range
 * the cut already commits to: without those bounds, moving to another segment
 * mid-edit would timestamp the statement outside the cut it belongs to.
 */
function isStatementAddDisabled(
  cutStart: Date | null,
  cutEnd: Date | null,
  playerDatetime: Date | null
): boolean {
  if (!cutStart || !playerDatetime) return true;

  return !isWithinCutWindow(playerDatetime, cutStart, cutEnd);
}

export { isStatementAddDisabled };
